export default __webpack_public_path__ + "static/media/et-logo-300dpi.f9126f7e.png";